import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import GlobalHeader from "../components/GlobalHeader";
import { Navigation } from "../pages/HomePage/Navigation";
import { useAuth } from "../contexts/AuthContext";
import { usePartnerInfo } from "../hooks/usePartnerInfo";

type TabType = "home" | "interviews" | "assessmentHistory" | "weeklyContest";

const LayoutWithHeaderAndNav: React.FC = () => {
  const { subscriptionPlan, hasActiveSubscription } = useAuth();
  const location = useLocation();
  const { isPartner, logo, displayName, logoHeaderClassName } =
    usePartnerInfo();

  // Determine active tab based on current path
  const getActiveTab = (pathname: string): TabType => {
    if (pathname === "/") return "home";
    if (pathname.includes("/interviews")) return "interviews";
    if (pathname.includes("/assessment-history")) return "assessmentHistory";
    if (pathname.includes("/weekly-contest")) return "weeklyContest";
    return "home";
  };

  const [activeTab, setActiveTab] = useState<TabType>(
    getActiveTab(location.pathname)
  );
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Update active tab when location changes
  React.useEffect(() => {
    setActiveTab(getActiveTab(location.pathname));
  }, [location.pathname]);

  // Check if we're in the interview process
  const isInInterview = location.pathname.includes("/mock-case");

  return (
    <div className="min-h-screen">
      <GlobalHeader
        subscriptionLevel={
          hasActiveSubscription ? subscriptionPlan?.name || "Free" : "Free"
        }
        hideUserIcon={isInInterview}
        companyLogo={isPartner && logo ? logo : undefined}
        companyName={isPartner && displayName ? displayName : undefined}
        companyLogoHeaderClassName={
          isPartner && logoHeaderClassName ? logoHeaderClassName : ""
        }
      />
      <Navigation
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />
      <main
        className={`transition-all duration-300 ${
          isCollapsed ? "ml-[72px]" : "ml-[240px]"
        }`}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutWithHeaderAndNav;
